import { render, staticRenderFns } from "./photoOverlay.vue?vue&type=template&id=76e8691d&scoped=true"
import script from "./photoOverlay.vue?vue&type=script&lang=js"
export * from "./photoOverlay.vue?vue&type=script&lang=js"
import style0 from "./photoOverlay.vue?vue&type=style&index=0&id=76e8691d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e8691d",
  null
  
)

export default component.exports